import type { DraftFormValues, DraftType } from './Draft.types.ts';
import type { GeneralRegulationType } from '../../types/regulation.ts';
import dayjs from 'dayjs';

export const normalize = (data: GeneralRegulationType, regType: number) => ({
  id: data?.id || null,
  author: data?.author
    ? [
        {
          value: data?.author?.entraId || '',
          label: data?.author?.displayName || '',
          key: data?.author?.email || '',
        },
      ]
    : null,
  topics: data?.topics?.map((topic: { id: string }) => topic.id) || [],
  targetGroupId: data?.targetGroup?.id || null,
  unitInChargeId: data?.unitInCharge ? data?.unitInCharge?.id : null,
  involvedUnits: data?.involvedUnits.map((unit: { id: number }) => unit.id),
  regulationNumber: data?.regulationNumber || '',
  title: data?.title || '',
  titleEnglish: data?.titleEnglish || '',
  isActive: data?.isActive,
  isDeleted: data?.isDeleted,
  links: data?.links,
  type: data?.type || regType || null,
  emergedOut: data?.emergedOut || '',
  shortDescription: data?.shortDescription || '',
  shortDescriptionEnglish: data?.shortDescriptionEnglish || '',
  content: data?.content || '',
  creationDate: data?.creationDate || '',
  publicationDate: data?.publicationDate || '',
  deletionDate: data?.deletionDate || '',
  confirmationDate: data?.confirmationDate || '',
  attachments: data?.attachments || [],
});

export const getDraftValues = (data: DraftType) => ({
  id: data?.id || null,
  title: data?.title || '',
  titleEnglish: data?.titleEnglish || '',
  isActive: data?.isActive,
  author: data?.author || null,
  links: data?.links || [],
  type: data?.type || null,
  emergedOut: data?.emergedOut || '',
  unitInChargeId: data?.unitInChargeId || null,
  involvedUnits: data?.involvedUnits || [],
  topics: data?.topics || [],
  targetGroupId: data?.targetGroupId || null,
  creationDate: data?.creationDate ? dayjs(data?.creationDate) : '',
  shortDescription: data?.shortDescription || '',
  shortDescriptionEnglish: data?.shortDescriptionEnglish || '',
  content: data?.content || '',
  attachments: data?.attachments || [],
});

export const getDraftData = (values: DraftFormValues) => ({
  id: values.id,
  title: values.title,
  titleEnglish: values.titleEnglish,
  author: {
    entraId: values?.author?.[0]?.value ?? '',
    displayName: values?.author?.[0]?.label ?? '',
    email: values?.author?.[0]?.key ?? '',
  },
  unitInChargeId: values.unitInChargeId,
  emergedOut: values.emergedOut,
  topics: values.topics,
  type: values.type,
  targetGroupId: values.targetGroupId,
  attachments: values?.attachments || [],
});